module.exports = __webpack_public_path__ + "media/images/flags/32/Zimbabwe-927eeb4e18ef7f9727560d6025daa38d.png";